export default {
  tractVisitTypes: [],
  loading: false
}
